export default "__VITE_ASSET__DwOKXFcT__"